import api from "../../services/axiosConfig";

const getReports = async (vehicleId, range) => {

    const response = await api.get(
        "/api/Reports/report",
        {
            params: {
                vehicleId,
                range,
            },
        }
    );

    return response.data;

};

export default getReports;
